import { render, staticRenderFns } from "./ChatContainer.vue?vue&type=template&id=d0ff3d24&scoped=true"
import script from "./ChatContainer.vue?vue&type=script&lang=js"
export * from "./ChatContainer.vue?vue&type=script&lang=js"
import style0 from "./ChatContainer.vue?vue&type=style&index=0&id=d0ff3d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ff3d24",
  null
  
)

export default component.exports